import React from 'react';
import styles from './BodyFormPermit.module.scss';
import AddressesRow from '../AddressesRow/AddressesRow';
import DateRow from '../DateRow/DateRow';
import InfoCard from '../../ui/InfoCard/InfoCard';
import moment from 'moment';
import BodyRow from '../BodyRow/BodyRow';

const BodyFormPermit = ({
  form,
  permit = {},
  isEdit,
  editingAcccess,
  companyId,
}) => {
  return (
    <div className={styles.root}>
      <AddressesRow
        form={form}
        permit={permit}
        isEdit={isEdit}
      />
      <BodyRow
        form={form}
        permit={permit}
        editingAcccess={editingAcccess}
        isEdit={isEdit}
        companyId={companyId}
      />
      <DateRow
        form={form}
        permit={permit}
        editingAcccess={editingAcccess}
        isEdit={isEdit}
      />
      {isEdit && (
        <div className={styles.gridBox}>
          <InfoCard
            title="Дата создания:"
            value={moment(permit?.insertDate)?.format('DD.MM.YYYY')}
          />
          {!!permit?.cancellationDate && (
            <InfoCard
              title="Дата аннулирования пропуска:"
              value={moment(permit?.cancellationDate)?.format('DD.MM.YYYY')}
            />
          )}

          <InfoCard
            title="Источник:"
            value={permit?.source?.name}
          />
        </div>
      )}
    </div>
  );
};

export default BodyFormPermit;
